import { render, staticRenderFns } from "./company.vue?vue&type=template&id=40eb3d80&scoped=true&"
var script = {}
import style0 from "./company.vue?vue&type=style&index=0&id=40eb3d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb3d80",
  null
  
)

component.options.__file = "company.vue"
export default component.exports